import { z } from "zod";

/**
 * An organisation shut out by a platform admin, as its own members see it: which one,
 * since a person can belong to several, and the reason they were given (ADR 0009).
 */
export const suspensionNoticeSchema = z.object({
  organisation: z.string(),
  reason: z.string(),
  suspendedAt: z.string(),
});
export type SuspensionNotice = z.infer<typeof suspensionNoticeSchema>;
